import { SortOrder } from '../sort-order';

export class SynopticFilters {
  sortField?: string;
  sortOrder?: SortOrder;
  name?: string;
  description?: string;
  tenantUuids?: string[];
  organizationUuids?: string[];
}
